/* ==========================================================================
   Giorgio header refresh — moves the account / cart icons out of the header
   row and into the announcement bar above it, on desktop only, wires a proxy
   search button there too, and (product pages only) clusters both nav menus
   beside a left-aligned logo.

   ACCOUNT + CART: moved for real
   Both identify themselves by id/class, not by position, and nothing in
   Dawn's own JS keys them to a fixed spot in the tree:
     - #cart-icon-bubble is a plain <a>. Cart re-renders find it by id and only
       ever replace its innerHTML, never the node itself, so it keeps working
       wherever it lives.
     - .header__icon--account's own <account-icon> element only adds a
       document-level listener in connectedCallback; that callback fires again
       on a move (a DOM move is spec'd as remove-then-insert), but the listener
       it adds is harmless to duplicate — no user-visible effect.

   SEARCH: forwarded, not moved
   The search trigger opens a full-viewport modal built from
   `position: absolute; inset: 0`, sized against whatever the nearest
   POSITIONED ancestor happens to be — normally the header. This icon cluster
   has to be `position: absolute` itself (to float over the bar without
   disturbing its grid), which means moving the real trigger+modal in here
   would make this tiny cluster the modal's sizing reference instead of the
   page: `position: fixed` escapes that for layout, but the modal's own
   "anchor near the bottom" math — tuned for a header-sized box — then lands
   the search field off-screen against a full-viewport-sized one instead.

   So the real trigger and its modal stay exactly where Dawn put them. The
   proxy button in the bar (rendered by announcement-bar.liquid) only forwards
   its click to that real, hidden trigger.

   Moving happens once per breakpoint crossing, not on every resize event, and
   the exact place each icon came from is marked with a comment node so
   shrinking back to mobile puts everything back where Dawn expects it.
   ========================================================================== */
(function () {
  'use strict';

  var MOVE_SELECTORS = ['.header__icon--account', '#cart-icon-bubble'];
  var mql = window.matchMedia('(min-width: 990px)');
  var moved = false;
  var markers = []; // { node, placeholder }

  function target() {
    return document.getElementById('GioBarIcons');
  }

  function realSearchTrigger() {
    return document.querySelector('.header__search summary.header__icon--search');
  }

  function proxySearchButton() {
    return document.querySelector('.gio-search-proxy');
  }

  function moveIn() {
    var dest = target();
    if (!dest || moved) return;

    markers = [];
    MOVE_SELECTORS.forEach(function (sel) {
      var node = document.querySelector(sel);
      if (!node) return;
      var placeholder = document.createComment('gio-icon-was-here:' + sel);
      node.parentNode.insertBefore(placeholder, node);
      dest.appendChild(node);
      markers.push({ node: node, placeholder: placeholder });
    });
    moved = markers.length > 0;

    var trigger = realSearchTrigger();
    if (trigger) trigger.style.display = 'none';
  }

  function moveOut() {
    if (moved) {
      markers.forEach(function (m) {
        if (m.placeholder.parentNode) {
          m.placeholder.parentNode.insertBefore(m.node, m.placeholder);
          m.placeholder.remove();
        }
      });
      markers = [];
      moved = false;
    }

    var trigger = realSearchTrigger();
    if (trigger) trigger.style.display = '';
  }

  function sync() {
    if (mql.matches) {
      moveIn();
    } else {
      moveOut();
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.gio-search-proxy')) return;
    event.preventDefault();
    var trigger = realSearchTrigger();
    if (trigger) trigger.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', sync);
  } else if (mql.addListener) {
    // Safari < 14.
    mql.addListener(sync);
  }

  /* ---- product pages: both nav menus grouped beside the logo ------------
     The header renders TWO separate <nav class="header__inline-menu"> trees:
     the main menu (a real grid item, in the "navigation" area) and a second
     one for Gifts/Wholesale that giorgio nested inside the icons area so it
     would sit at the header's far right. Getting both to read as one cluster
     right after the logo means they have to become DOM siblings inside a
     single wrapper — a CSS grid-area can host one layout position, not two
     independently-placed items.

     This runs once, unconditionally (not gated to the desktop matchMedia
     the icon relocation uses): .header__inline-menu is already display:none
     below 990px regardless of which parent holds it, and Dawn's mobile
     hamburger menu is a wholly separate markup tree (header-drawer), so
     regrouping these two here has no effect on mobile to begin with — nothing
     to move back on resize. */
  function groupProductNav() {
    if (!document.body.classList.contains('product')) return;

    var mainMenu = document.querySelector('.header > .header__inline-menu');
    var secondMenu = document.querySelector('.header__icons .header__inline-menu');
    if (!mainMenu || !secondMenu || mainMenu === secondMenu) return;

    var group = document.createElement('div');
    group.className = 'gio-product-nav-group';
    mainMenu.parentNode.insertBefore(group, mainMenu);
    group.appendChild(mainMenu);
    group.appendChild(secondMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupProductNav);
  } else {
    groupProductNav();
  }
})();
